const getJQuery = () => /** @type {any} */ (window).jQuery;

/**
 * @callback JournalMenuClickOutHandler
 * @param {Event} event
 * @returns {void}
 */

/**
 * @typedef {object} EasyClickObserver
 * @property {(target: { clickOutCallback: JournalMenuClickOutHandler }) => void} [addClickTarget]
 */

const closeVisibleJournalMenus = () => {
  const $ = getJQuery();

  $(".journal-tools .menu-more:visible").hide().addClass("collapsed");
  $(".journal-tools .menu-expander").removeClass("open icon-remove icon-add");
};

/** @returns {JournalMenuClickOutHandler} */
const getJournalMenuClickOutHandler = () => {
  window.EASY ||= {};

  const easyWindow = /** @type {Record<string, any>} */ (window.EASY);
  const storedClickOutHandler = /** @type {JournalMenuClickOutHandler | undefined} */ (
    easyWindow._journalMenuClickOutHandler
  );

  if (storedClickOutHandler) {
    return storedClickOutHandler;
  }

  /** @type {JournalMenuClickOutHandler} */
  const clickOutHandler = event => {
    const $ = getJQuery();

    if ($(event.target).closest(".journal-tools").length === 0) {
      closeVisibleJournalMenus();
    }
  };

  easyWindow._journalMenuClickOutHandler = clickOutHandler;

  return clickOutHandler;
};

/**
 * @param {JournalMenuClickOutHandler} clickOutHandler
 * @returns {void}
 */
const bindJournalMenuClickOutHandler = clickOutHandler => {
  const easyWindow = /** @type {Record<string, any>} */ (window.EASY);

  if (!easyWindow._journalMenuCaptureHandlerBound) {
    document.addEventListener("click", clickOutHandler, true);
    easyWindow._journalMenuCaptureHandlerBound = true;
  }

  const defaultClickObserver = /** @type {EasyClickObserver | undefined} */ (easyWindow.defaultClickObserver);

  if (defaultClickObserver?.addClickTarget && !easyWindow._journalMenuObserverBound) {
    defaultClickObserver.addClickTarget({ clickOutCallback: clickOutHandler });
    easyWindow._journalMenuObserverBound = true;
  }
};

/**
 * @param {HTMLElement} triggerElement
 * @returns {void}
 */
export const handleJournalMenuExpander = triggerElement => {
  const $ = getJQuery();
  const popupMenu = $(triggerElement).siblings(".menu-more");
  const menuOpen = popupMenu.is(":visible");
  const clickOutHandler = getJournalMenuClickOutHandler();

  bindJournalMenuClickOutHandler(clickOutHandler);

  $(".journal-tools .menu-expander").not(triggerElement).removeClass("open icon-remove icon-add");
  $(".journal-tools .menu-more").not(popupMenu).hide().addClass("collapsed");
  $(triggerElement).toggleClass("open", menuOpen);
};
